module.exports = __webpack_public_path__ + "static/media/share-invite.84942ff3.png";